import { Component, Inject, NgZone, OnInit } from '@angular/core';
import { OpenDialog, AlertDialog } from '../../shared/dialogs/dialog';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { AccountService } from '../../services/account.service';
import { SuperAdminService } from '../../services/super-admin.service';

import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-prd-signup-resubmit',
  templateUrl: './prd-signup-resubmit.component.html',
  styleUrls: ['./prd-signup-resubmit.component.scss'],
})
export class PrdSignupResubmitComponent implements OnInit {
  active: boolean;
  actTab = 'tab1';

  filterForm: FormGroup;

  currentUser: any;
  isManagePrdSignUP;
  isAdmin: boolean;
  adminOptions: boolean;
  viewProducts: boolean;
  setUserAccess: boolean;

  HIDE_CALS_DIGITAL_SIGNUP = new FormControl();
  HIDE_CALI_DIGITAL_SIGNUP = new FormControl();
  HIDE_CALT_DIGITAL_SIGNUP = new FormControl();
  HIDE_CALS_BALANCE = new FormControl();
  HIDE_CALI_BALANCE = new FormControl();
  HIDE_CALT_BALANCE = new FormControl();
  HIDE_PWM_BALANCE = new FormControl();
  HIDE_CALS_GRAPH = new FormControl();
  HIDE_CALI_GRAPH = new FormControl();
  HIDE_CALT_GRAPH = new FormControl();
  HIDE_PWM_GRAPH = new FormControl();
  isSuperAdmin: any;
  constructor(
    private accountService: AccountService,
    private superAdminService: SuperAdminService,
    private ngZone: NgZone,
    @Inject(DOCUMENT) private document: Document
  ) {
    window.onresize = (e) => {
      this.ngZone.run(() => {
        if (this.document.body.offsetWidth < 768) {
          if (this.document.body.className === 'sidebar-collapse-in') {
            this.document.body.classList.toggle('sidebar-collapse-in');
            this.accountService.emit(false);
          }
        } else {
          if (!this.document.body.className) {
            this.document.body.classList.add('sidebar-collapse-in');
            this.accountService.emit(true);
          }
        }
      });
    };
  }

  async ngOnInit() {
    this.currentUser = await this.accountService.currentUserAsync();

    this.isSuperAdmin = this.currentUser.priviledges.some((priviledge) => priviledge === 'ADMIN_OPTIONS') || false;
    this.isManagePrdSignUP = this.currentUser.priviledges.some((priviledge) => priviledge === 'MANAGE_ADMIN_USERS') || false;
    try {
      let signupPermission = await this.accountService.getSignUpPermission();
      this.setPermissions(signupPermission);
    } catch (e) {}
    if (this.document.body.offsetWidth > 767) {
      this.document.body.classList.add('sidebar-collapse-in');
      this.accountService.emit(true);
    }
  }
  setPermissions(data) {
    this.HIDE_CALS_DIGITAL_SIGNUP.setValue(!data.HIDE_CALS_DIGITAL_SIGNUP);
    this.HIDE_CALI_DIGITAL_SIGNUP.setValue(!data.HIDE_CALI_DIGITAL_SIGNUP);
    this.HIDE_CALT_DIGITAL_SIGNUP.setValue(!data.HIDE_CALT_DIGITAL_SIGNUP);
    this.HIDE_CALS_BALANCE.setValue(!data.HIDE_CALS_BALANCE);
    this.HIDE_CALI_BALANCE.setValue(!data.HIDE_CALI_BALANCE);
    this.HIDE_CALT_BALANCE.setValue(!data.HIDE_CALT_BALANCE);
    this.HIDE_PWM_BALANCE.setValue(!data.HIDE_PWM_BALANCE);
    this.HIDE_CALS_GRAPH.setValue(!data.HIDE_CALS_GRAPH);
    this.HIDE_CALI_GRAPH.setValue(!data.HIDE_CALI_GRAPH);
    this.HIDE_CALT_GRAPH.setValue(!data.HIDE_CALT_GRAPH);
    this.HIDE_PWM_GRAPH.setValue(!data.HIDE_PWM_GRAPH);
  }

  enableProductsWithFields(user) {
    // OpenDialog(EnableProductsWithSpecificFieldsComponent, user);
  }

  activeTab(tab) {
    this.actTab = tab;
  }
  async btnToggle(btn, type = '') {
    // try {
    //   await this.superAdminService.updateApplicationParam({
    //     paramKey: btn,
    //     paramValue: this[btn].value,
    //   });
    // AlertDialog(`${type} ${(this[btn].value && 'Enabled') || 'Disabled'}`, 'Change Permission', 'Ok');
    // } catch (e) {
    //   AlertDialog(`${type} Error Occured`, 'Change Permission', 'Ok');
    //   this[btn].setValue(!this[btn].value, { emitEvent: false });
    // }
  }
}
